import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import type { DateRangeKey } from '../types';

const RANGE_OPTIONS: Array<{ key: DateRangeKey; label: string }> = [
  { key: 'day', label: 'Day' },
  { key: 'last_week', label: 'Last week' },
  { key: 'last_month', label: 'Last month' },
  { key: 'last_3_months', label: 'Last 3 months' },
  { key: 'previous_week', label: 'Previous week' },
  { key: 'previous_month', label: 'Previous month' },
];

interface Props {
  value: DateRangeKey;
  onChange: (next: DateRangeKey) => void;
}

const DateRangeSelector: React.FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const activeOption = RANGE_OPTIONS.find((o) => o.key === value) ?? RANGE_OPTIONS[0];

  return (
    <Dropdown isOpen={open} toggle={() => setOpen((v) => !v)} data-testid="date-range-selector">
      <DropdownToggle caret color="secondary" outline data-testid="date-range-selector-toggle">
        {activeOption.label}
      </DropdownToggle>
      <DropdownMenu>
        {RANGE_OPTIONS.map((option) => (
          <DropdownItem
            key={option.key}
            active={option.key === value}
            data-testid={`range-option-${option.key}`}
            onClick={() => onChange(option.key)}
          >
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default DateRangeSelector;
export { RANGE_OPTIONS };
